import { Component } from '@angular/core';

@Component({
  selector: 'app-workorder',
  templateUrl: './workorder.component.html',
  styleUrl: './workorder.component.css'
})
export class WorkorderComponent {

}
